import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const filterActive: ISVGPersonalProps = {
  viewBox: '0 0 36.025 36.133',
  content: (
    <g id="filter-default" transform="translate(0 0.107)">
      <g
        id="Rectangle_995"
        data-name="Rectangle 995"
        transform="translate(0.002 -0.107)"
        fill="#79CDD0"
        stroke="#ffffff"
        strokeWidth="1"
      >
        <rect width="36" height="36" rx="18" stroke="none" />
        <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" fill="none" />
      </g>
      <g id="filter-default-2" data-name="filter-default" transform="translate(9 9)">
        <path
          id="Path_7129"
          data-name="Path 7129"
          d="M6,6.751A.753.753,0,0,1,6.751,6H18.768a.753.753,0,0,1,.751.751V8.693a.753.753,0,0,1-.222.533L14.483,14.04a.753.753,0,0,0-.222.533v1.941l-3,3V14.573a.753.753,0,0,0-.222-.533L6.222,9.226A.753.753,0,0,1,6,8.693Z"
          transform="translate(-3.747 -3.747)"
          fill="none"
          stroke="#ffffff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path id="Path_7130" data-name="Path 7130" d="M0,0H18.025V18.025H0Z" fill="none" />
      </g>
    </g>
  ),
};
